<template>
  <div
    class="modal"
    style="display:block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span v-if="mode === modalWindowTypes.CREATE">Add new webhook</span>
              <span v-if="mode === modalWindowTypes.EDIT">Edit webhook</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Enter the URL to post to</label>
                <input
                  class="form-control"
                  v-model="models.url"
                  type="text"
                  name="url"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="mode === modalWindowTypes.CREATE"
            class="btn btn-success"
            @click="add()"
          >
            Add
          </button>
          <button
            v-if="mode === modalWindowTypes.EDIT"
            class="btn btn-success"
            @click="save()"
          >
            Save
          </button>
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  modalWindowTypes
} from '@/utils/dictionaries'

export default {
  name: 'ModalWebhook',
  props: {
    model: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: modalWindowTypes.CREATE
    }
  },
  data: () => (
    {
      models: {
        url: 'http://'
      }
    }
  ),
  computed: {
    modalWindowTypes() {
      return modalWindowTypes
    }
  },
  mounted() {
    if (this.model !== null) {
      this.updateData()
    }
  },
  methods: {
    add() {
      this.$emit('add', { ...this.$data.models })
    },
    save() {
      this.$emit('save', { ...this.$data.models })
      this.clearData()
    },
    close() {
      this.$emit('close')
    },
    updateData() {
      for (const key in this.models) {
        this.models[key] = this.model.value[key]
      }
    },
    clearData() {
      this.models.url = 'http://'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalWebhook.vue